import * as types from './constants';

// Get DataExports
export const getDataExportsRequest = data => (
  { type: types.GET_DATA_EXPORTS_REQUEST, payload: data }
);

export const getDataExportsDone = data => (
  { type: types.GET_DATA_EXPORTS_DONE, payload: data }
);

export const getDataExportsFailed = errors => (
  { type: types.GET_DATA_EXPORTS_FAILED, payload: errors }
);

// Operations
export const dataExportsSetPage = data => (
  { type: types.DATA_EXPORTS_SET_PAGE, payload: data }
);